"use client";

import { useEffect } from "react";

import { usePathname } from "@ala/core/navigation";

import { useHistoryTrackerStore } from "./history-tracker.store";

export const HistoryTracker = () => {
  const pathname = usePathname();
  const registerNavigation = useHistoryTrackerStore((state) => state.registerNavigation);

  useEffect(() => {
    window.addEventListener("popstate", registerNavigation);

    return () => window.removeEventListener("popstate", registerNavigation);
  }, [registerNavigation]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: Next's navigation might slip undetected by the popstate event
  useEffect(() => {
    registerNavigation();
  }, [pathname]);

  return null;
};
